// stores/panelDataStore.signals.ts — server-signal (symbol:interval) write paths.
//
// Extracted from panelDataStore.ts so that file stays < 250 LOC (the same
// delegation pattern as panelDataStore.older.ts: the store's addEma/addRsi
// actions are thin delegates to runAddEma/runAddRsi taking (set, …)).
//
// Server-computed signal series (ema/rsi/macd/sma/…) are keyed by symbol:interval
// and appended as they arrive over WS. They are NOT derived client-side — the
// candle path (dataByKey, keyed by symbol) is the only client-derived series.

import { blankSignal } from './panelDataMutations';
import type { EmaPoint, RsiPoint } from './indicatorStore';
import type { IntervalKey, PanelDataState } from './panelDataStore.types';

type Set = (
  partial:
    | Partial<PanelDataState>
    | ((s: PanelDataState) => Partial<PanelDataState>),
) => void;

/** Append one EMA point to `signalByKey[key].ema[period]` (immutable update). */
export function runAddEma(
  set: Set,
  key: IntervalKey,
  period: number,
  point: EmaPoint,
): void {
  set((s) => {
    const prior = s.signalByKey[key] ?? blankSignal(key);
    const series = prior.ema[period] ?? [];
    return {
      signalByKey: {
        ...s.signalByKey,
        [key]: {
          ...prior,
          ema: { ...prior.ema, [period]: [...series, point] },
        },
      },
    };
  });
}

/** Append one RSI point to `signalByKey[key].rsi` (immutable update). */
export function runAddRsi(set: Set, key: IntervalKey, point: RsiPoint): void {
  set((s) => {
    const prior = s.signalByKey[key] ?? blankSignal(key);
    return {
      signalByKey: {
        ...s.signalByKey,
        [key]: { ...prior, rsi: [...prior.rsi, point] },
      },
    };
  });
}
